import React from 'react';

const ProfileDropdownItemIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M9.99935 1.6665C7.81602 1.6665 6.04102 3.4415 6.04102 5.62484C6.04102 7.7665 7.71602 9.49984 9.89935 9.57484C9.96602 9.5665 10.0327 9.5665 10.0827 9.57484C10.0993 9.57484 10.1077 9.57484 10.1243 9.57484C10.1327 9.57484 10.1327 9.57484 10.141 9.57484C12.2743 9.49984 13.9493 7.7665 13.9577 5.62484C13.9577 3.4415 12.1827 1.6665 9.99935 1.6665Z"
      fill="#12B76A"
    />
    <path
      d="M14.2328 11.7919C11.9078 10.2419 8.11615 10.2419 5.77448 11.7919C4.71615 12.5002 4.13281 13.4586 4.13281 14.4836C4.13281 15.5086 4.71615 16.4586 5.76615 17.1586C6.93281 17.9419 8.46615 18.3336 9.99948 18.3336C11.5328 18.3336 13.0661 17.9419 14.2328 17.1586C15.2828 16.4502 15.8661 15.5002 15.8661 14.4669C15.8578 13.4419 15.2828 12.4919 14.2328 11.7919Z"
      fill="#12B76A"
    />
  </svg>
);

export default ProfileDropdownItemIcon;
